var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomV2Girl(_ref, svgRef) {
  var _ref2, _ref3, _ref4;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 9.99964,
    cy: 7.49915,
    r: 5.00208,
    stroke: "#7A7670",
    style: (_ref2 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99985 17.5031V12.501",
    stroke: "#7A7670",
    style: (_ref3 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49854 15.8358H12.5006",
    stroke: "#7A7670",
    style: (_ref4 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomV2Girl);
export default __webpack_public_path__ + "static/media/customV2girl.7cf3934e097746cada8cc3dc4a3a3663.svg";
export { ForwardRef as ReactComponent };